"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assertIso8601ish = exports.iso8601ish = exports.isDateOnly = void 0;
var iso8601ishRegex = /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}:\d{2}(([+-]\d{2}:\d{2})|Z)?)?$/;
var iso8601DateOnly = /^\d{4}-\d{2}-\d{2}$/;
/** Determine if the provided string is only a date part of the ISO8601 spec */

var isDateOnly = function isDateOnly(s) {
  return s.match(iso8601DateOnly) !== null;
};
/** Determine if a string forms an ISO8601 date.
 *
 * We only want to accept a few types of dates. We don't need to accept the full ISO8601 spec.
 *
 * @param date
 */


exports.isDateOnly = isDateOnly;

var iso8601ish = function iso8601ish(date) {
  return date.match(iso8601ishRegex) !== null;
};
/** Throw an error if the provided string is not a form of date we accept */


exports.iso8601ish = iso8601ish;

var assertIso8601ish = function assertIso8601ish(s) {
  if (!s || !iso8601ish(s)) {
    throw new Error('This is not a valid date, from our perspective with an optional time component. See the tests for more examples.');
  }
};

exports.assertIso8601ish = assertIso8601ish;